var _circle, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarvinIconSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.0005,
    cy: 14.0007,
    r: 13.5005,
    fill: "white",
    stroke: "url(#paint0_linear_1208_5019)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.19082 8.1953C6.0727 8.55117 6.16506 8.94323 6.4296 9.20895L7.72445 10.3243L7.69487 10.302L12.6186 14.765C12.8476 14.9725 13.1455 15.0875 13.4545 15.0875C13.7601 15.0875 14.0549 14.9751 14.283 14.7717L16.4038 12.8805L14.9164 11.4557L13.4936 12.8481L8.18344 7.64117C7.89513 7.35847 7.48335 7.24087 7.08923 7.32869L7.07048 7.33286C6.67298 7.42143 6.35117 7.7122 6.22288 8.09872L6.19082 8.1953Z",
    fill: "url(#paint1_linear_1208_5019)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7861 10.6045L17.3143 12.0685L19.1793 10.4054L19.1978 20.7866C19.1988 21.3308 19.6402 21.7714 20.1844 21.7714C20.7292 21.7714 21.1709 21.3297 21.1709 20.7849V8.20857C21.1709 7.5411 20.6298 7 19.9623 7C19.6463 7 19.3429 7.12378 19.117 7.34481L15.7861 10.6045Z",
    fill: "url(#paint2_linear_1208_5019)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.10396 13.4679C9.0097 12.6978 8.3534 12.1013 7.55779 12.1013C6.69745 12.1013 6 12.7988 6 13.6591C6 14.142 6.21968 14.5735 6.56455 14.8593L6.5646 18.9765C6.2197 19.2623 6 19.6938 6 20.1767C6 21.0371 6.69745 21.7345 7.55779 21.7345C8.41814 21.7345 9.11558 21.0371 9.11558 20.1767C9.11558 20.1104 9.11144 20.0451 9.1034 19.9809L10.8466 18.2378C11.0682 18.359 11.3225 18.4279 11.5929 18.4279C12.4533 18.4279 13.1507 17.7304 13.1507 16.8701C13.1507 16.0097 12.4533 15.3123 11.5929 15.3123C11.4008 15.3123 11.2167 15.3471 11.0468 15.4107L9.10396 13.4679ZM7.55779 14.2583C7.88869 14.2583 8.15694 13.99 8.15694 13.6591C8.15694 13.3282 7.88869 13.06 7.55779 13.06C7.22689 13.06 6.95864 13.3282 6.95864 13.6591C6.95864 13.99 7.22689 14.2583 7.55779 14.2583ZM8.61394 14.8042C8.40518 14.9969 8.14362 15.1332 7.85342 15.1889L7.85346 18.6469C8.04982 18.6847 8.23307 18.7593 8.39572 18.8632L10.0682 17.1908C10.0465 17.0873 10.0352 16.98 10.0352 16.8701C10.0352 16.6779 10.07 16.4939 10.1336 16.3239L8.61394 14.8042ZM8.15694 20.1767C8.15694 20.5076 7.88869 20.7759 7.55779 20.7759C7.22689 20.7759 6.95864 20.5076 6.95864 20.1767C6.95864 19.8458 7.22689 19.5776 7.55779 19.5776C7.88869 19.5776 8.15694 19.8458 8.15694 20.1767ZM11.5929 17.4692C11.9239 17.4692 12.1921 17.201 12.1921 16.8701C12.1921 16.5392 11.9239 16.2709 11.5929 16.2709C11.262 16.2709 10.9938 16.5392 10.9938 16.8701C10.9938 17.201 11.262 17.4692 11.5929 17.4692Z",
    fill: "url(#paint3_linear_1208_5019)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1208_5019",
    x1: 3.5,
    y1: 4.50023,
    x2: 24.5,
    y2: 28.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51087E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB8B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1208_5019",
    x1: 4.30325,
    y1: 7,
    x2: 24.1385,
    y2: 7.17355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51087E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674211,
    stopColor: "#A14653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB8B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1208_5019",
    x1: 4.30325,
    y1: 7,
    x2: 24.1385,
    y2: 7.17355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51087E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674211,
    stopColor: "#A14653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB8B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1208_5019",
    x1: 4.30325,
    y1: 7,
    x2: 24.1385,
    y2: 7.17355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51087E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674211,
    stopColor: "#A14653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB8B23"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarvinIconSelected);
export default __webpack_public_path__ + "static/media/marvinIconSelected.97a62fb09b25f5b97642ce41b7754297.svg";
export { ForwardRef as ReactComponent };